"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignOfferFilesButton = SignOfferFilesButton;
exports.UploadSignedOfferFileButton = UploadSignedOfferFileButton;
const react_1 = __importStar(require("react"));
const SigningRowActions_1 = require("../../Signing/SigningRowActions");
const offerSigningSource_1 = require("./offerSigningSource");
/** To samo oznaczenie co w wierszu listy ofert: typ kontraktu i miasto. */
const offerListLabel = (offer) => [offer._type?.name, offer._city?.name].filter(Boolean).join(" ") || undefined;
/**
 * Akcja wiersza „PDF z podpisem” dla ofert, zewnętrznych i własnych (decyzja właściciela 2026-10-10).
 * Skąd brać pliki (podfolder „Oferta” albo folder „Przygotowanie oferty”), rozstrzyga serwer.
 */
function SignOfferFilesButton({ dataObject, layout }) {
    const { id, alias, employerName } = dataObject;
    const listLabel = offerListLabel(dataObject);
    const source = (0, react_1.useMemo)(() => (0, offerSigningSource_1.offerSigningSource)({ id, alias, employerName, listLabel }), [id, alias, employerName, listLabel]);
    return react_1.default.createElement(SigningRowActions_1.SignPdfRowAction, { source: source, layout: layout });
}
/** Akcja wiersza „Wgraj podpisany” dla ofert. */
function UploadSignedOfferFileButton({ dataObject, layout }) {
    const { id, alias, employerName } = dataObject;
    const listLabel = offerListLabel(dataObject);
    const source = (0, react_1.useMemo)(() => (0, offerSigningSource_1.offerSigningSource)({ id, alias, employerName, listLabel }), [id, alias, employerName, listLabel]);
    return react_1.default.createElement(SigningRowActions_1.UploadSignedRowAction, { source: source, layout: layout });
}
